import dayjs from "dayjs";

export const CATEGORIES = [
    "Comunicazioni informative/operative",
    "Nuove partnership",
    "Nuovi progetti",
];

export interface Communication {
    id: number;
    title: string;
    category: string;
    lastUpdateDate: string; // format: "DD/MM/YYYY"
    lastUpdateTime: string;
    hasAttachment: boolean;
    eclaimUsername:string;
}

/** Full detail — returned by GET /api/communications/:id */
export interface CommunicationDetail extends Communication {
    body: string;
    /** All ATTACHMENT-type records for this communication. */
    attachments: { id: number; fileName: string }[];
}

/**
 * Returns true if any communication in the list was created within the last 15 days.
 */
export function hasNewCommunications(communications: Pick<Communication, "lastUpdateDate">[]): boolean {
    const fifteenDaysAgo = dayjs().subtract(15, "day");
    return communications.some((c) => {
        const [day, month, year] = c.lastUpdateDate.split("/").map(Number);
        const commDate = dayjs(new Date(year, month - 1, day));
        return commDate.isAfter(fifteenDaysAgo);
    });
}
